import React, { useState, useEffect } from "react";
import axios from "axios";

import { getIdToken, getUser } from "../../../../utils/storage";
import {
  fetchCampaignStatuses,
  getTotalSurveyQuestions,
  stopCampaign,
  toggleSurveyStatus,
} from "../../../../services/dashboard-api";

const TotalQuestionsAndCost = (props) => {
  const { clientRef, campaign, totalRespondents, setToast } = props;

  const uid = getUser().uid,
    idToken = getIdToken();

  const [totalQuestions, setTotalQuestions] = useState(0);
  const [isEndingSurvey, setIsEndingSurvey] = useState(false);
  const [isChangingSurveyStatus, setIsChangingSurveyStatus] = useState(false);
  const [surveyStatus, setSurveyStatus] = useState(campaign.status);
  const [campaignStatuses, setCampaignStatuses] = useState({});

  // const handleToggleSurveyStatus = () => {
  //   setIsChangingSurveyStatus(true);
  //   axios
  //     .post(
  //       `${process.env.REACT_APP_API_BASE_URL}/versus_v2_toggle_survey_status`,
  //       {
  //         uid,
  //         idToken,
  //         clientRef,
  //         mediaType: "text",
  //         campaignRef: campaign.campaignRef,
  //       }
  //     )
  //     .then(({ data }) => {
  //       setSurveyStatus(data?.data?.status);
  //     })
  //     .catch((error) => {
  //       setToast({
  //         show: true,
  //         type: "warning",
  //         message: "Error Changing survey status. Please refresh",
  //       });
  //     })
  //     .finally(() => {
  //       setIsChangingSurveyStatus(false);
  //     });
  // };

  const handleToggleSurveyStatus = async () => {
    try {
      setIsChangingSurveyStatus(true);

      const { data } = await toggleSurveyStatus({
        clientRef,
        campaignRef: campaign.campaignRef,
        mediaType: "text",
      });
      console.log("Survey status changed:", data);
      setSurveyStatus(data?.data?.status);

      setToast({
        show: true,
        type: "success",
        message: data?.message || "Survey status updated",
      });
    } catch (error) {
      console.error("Error changing survey status:", error);

      setToast({
        show: true,
        type: "warning",
        message:
          error?.response?.data?.message ||
          "Error changing survey status. Please refresh.",
      });
    } finally {
      setIsChangingSurveyStatus(false);
    }
  };

  // const handleEndSurvey = () => {
  //   setIsEndingSurvey(true);
  //   axios
  //     .post(
  //       `${process.env.REACT_APP_API_BASE_URL}/versus_v2_stop_campaign`,
  //       {
  //         uid,
  //         idToken,
  //         clientRef,
  //         campaignRef: campaign.campaignRef,
  //       },
  //       { headers: { "content-type": "application/json" } }
  //     )
  //     .then(() => {
  //       window.location.reload();
  //     })
  //     .catch((error) => {
  //       setToast({
  //         show: true,
  //         type: "warning",
  //         message: "Error Ending survey. Please refresh",
  //       });
  //     })
  //     .finally(() => {
  //       setIsEndingSurvey(false);
  //     });
  // };

  const handleEndSurvey = async () => {
    try {
      setIsEndingSurvey(true);

      const { data } = await stopCampaign({
        campaignRef: campaign.campaignRef,
        clientRef,
      });

      setToast({
        show: true,
        type: "success",
        message: data?.message || "Campaign stopped successfully",
      });

      // or update local state if preferred
      window.location.reload();
    } catch (error) {
      console.error("Error stopping campaign:", error);

      setToast({
        show: true,
        type: "warning",
        message:
          error?.response?.data?.message ||
          "Error ending survey. Please refresh.",
      });
    } finally {
      setIsEndingSurvey(false);
    }
  };

  // useEffect(() => {
  //   axios
  //     .post(
  //       `${process.env.REACT_APP_API_BASE_URL}/versus_v2_get_total_survey_questions`,
  //       {
  //         uid,
  //         idToken,
  //         clientRef,
  //         campaignRef: campaign.campaignRef,
  //       },
  //       { headers: { "content-type": "application/json" } }
  //     )
  //     .then(({ data }) => {
  //       setTotalQuestions(data.totalSurveyQuestions);
  //     })
  //     .catch((error) => {
  //       setToast({
  //         show: true,
  //         type: "warning",
  //         message: "Error fetching questions. Please refresh",
  //       });
  //     });
  // }, []);

  useEffect(() => {
    const fetchTotalQuestions = async () => {
      try {
        const { data } = await getTotalSurveyQuestions({
          clientRef,
          campaignRef: campaign.campaignRef,
        });

        setTotalQuestions(data.totalSurveyQuestions);
      } catch (error) {
        console.error("Error fetching total survey questions:", error);

        setToast({
          show: true,
          type: "warning",
          message:
            error?.response?.data?.message ||
            "Error fetching questions. Please refresh",
        });
      }
    };

    fetchTotalQuestions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const loadCampaignStatuses = async () => {
      try {
        const { data } = await fetchCampaignStatuses();

        const statusMap = data.data.reduce((acc, item) => {
          acc[item.id] = item.value;
          return acc;
        }, {});

        setCampaignStatuses(statusMap);
      } catch (error) {
        console.error("Error loading campaign statuses", error);
      }
    };

    loadCampaignStatuses();
  }, []);

  const currentStatus =
    campaignStatuses[surveyStatus] || campaignStatuses[campaign?.status] || "";

  return (
    <>
      <div>
        <div className="chip bold push-up blue">
          {console.log("surveyStatus", currentStatus)}
          {currentStatus}
        </div>
        {["live", "paused"].includes(currentStatus) ? (
          <span
            id="btn-survey"
            data-w-id="b69e4f6b-ec32-1c13-05ac-a389f1135f49"
            className={`button small subtle float-right no-margin w-button ${
              isChangingSurveyStatus ? "is-disabled" : ""
            } `}
            onClick={() => {
              if (!isChangingSurveyStatus) {
                handleToggleSurveyStatus();
              }
            }}
          >
            {currentStatus === "paused" ? "Resume survey" : "Pause survey"}
          </span>
        ) : (
          ""
        )}

        <div className="call-out push-up">
          <div className="small-text">
            <strong>{totalQuestions}</strong> questions x{" "}
            <strong>{totalRespondents}</strong> respondents
          </div>
          <div className="divider move-down purple"></div>
          <div className="row spaced">
            <div className="small-text uppercase">Total Cost</div>
            <div className="primary bold">
              {totalQuestions * totalRespondents} VC
            </div>
          </div>
        </div>
      </div>
      {["live", "paused"].includes(currentStatus) ? (
        <div className="cta-btns">
          <span
            id="survey-status"
            onClick={handleEndSurvey}
            className={`button primary wide w-button ${
              isEndingSurvey ? "is-disabled" : ""
            }`}
          >
            End survey
          </span>
        </div>
      ) : (
        ""
      )}
      <div className="divider in-sidebar"></div>
      <div>
        <div className="data huge">{totalQuestions}</div>
        <h3 className="move-down">Questions</h3>
      </div>
    </>
  );
};

export default TotalQuestionsAndCost;
